import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'
import { Align } from 'core/elements/tooltip/Tooltip'

interface VMStatePicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: Align | 'left' | 'right'
  [key: string]: any
}

export const VMStates = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Building', value: 'BUILDING' },
  { label: 'Deleted', value: 'DELETED' },
  { label: 'Error', value: 'ERROR' },
  { label: 'Paused', value: 'PAUSED' },
  { label: 'Rescued', value: 'RESCUED' },
  { label: 'Resized', value: 'RESIZED' },
  { label: 'Shelved', value: 'SHELVED' },
  { label: 'Shelved Offloaded', value: 'SHELVED_OFFLOADED' },
  { label: 'Soft Deleted', value: 'SOFT_DELETED' },
  { label: 'Stopped', value: 'STOPPED' },
  { label: 'Suspended', value: 'SUSPENDED' },
]

export default function VMStatePicklist({
  disabled = false,
  name = 'vm_state',
  label = 'VM State',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'left',
  labelPosition = 'top',
  ...rest
}: VMStatePicklistProps) {
  const items = useMemo(() => {
    const result = []
    if (includeAllOption) {
      result.push({ label: 'All', value: 'all' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...VMStates]
  }, [includeNoneOption, includeAllOption])

  return compact ? (
    <Dropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      items={items}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      onChange={(item) => onChange(item.value)}
      value={value}
      {...(labelPosition === 'left' ? { showLabelOnLeft: true } : { showLabelOnTop: true })}
      align={align as 'left' | 'right'}
      disabled={disabled}
      width={width}
    />
  )
}
